<template>
  <div v-show="showDialog" class="ubi_copy">
    <div class="mask" />
    <div :class="{new_ubi_copy_box: newUbiStyle}" class="ubi_copy_box">
      <div class="header">
        <div class="info"> {{ $t('common.info') }} </div>
        <i class="aui_close2" @click="closeDialog">×</i>
      </div>
      <div class="content"> {{ copyTips }} </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    copyTips: {
      type: String,
      default: ''
    },
    newUbiStyle: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showDialog: false
    }
  },
  mounted() {
  },
  methods: {
    closeDialog() {
      this.showDialog = false
    }
  }
}
</script>
<style lang='scss' scoped>
  .ubi_copy {
    .mask {
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.2);
      z-index: 1001;
    }
    .ubi_copy_box {
      position: fixed;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 200px;
      background: #85BAE5;
      box-shadow: 0px 0px 15px 0px rgba(133,186,229,0.75);
      border-radius: 6px;
      z-index: 1003;
      &.new_ubi_copy_box {
        background: $menuBgcOragne;
        box-shadow: 0px 0px 15px 0px rgba(242,196,109,0.75);
      }
      .header {
        position: relative;
        color: #fff;
        font-size: 12px;
        height: 30px;
        line-height: 30px;
        padding-left: 10px;
        .info {}
        .aui_close2 {
          position: absolute;
          right: 5px;
          top: 5px;
          color: #fff;
          width: 9px;
          height: 9px;
          line-height: 18px;
          font-size: 15px;
          cursor: pointer;
          font-style: normal;
        }
      }
      .content {
        background: #fff;
        color: #323232;
        height: 54px;
        line-height: 54px;
        text-align: center;
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
      }
    }
  }
</style>
